module.exports = __webpack_public_path__ + "static/media/permaguard.3679859e.svg";